
<div
  :class="classes(
    n(),
    n(`--${theme}`),
    [rounded, n('--rounded')]
  )
  "
  :role="noticeBarRole"
  :aria-label="content"
  @click="onClickNoticeBar"
>
  <!-- 左侧icon -->
  <div
    :class="classes(n('prefix-icon'))"
    aria-hidden="true"
  >
    <template v-if="$slots.prefixIcon">
      <slot name="prefixIcon" />
    </template>
    <component
      :is="prefixIconComp"
      v-else
      width="1em"
    />
  </div>
  <!-- 内容 -->
  <div :class="classes(n('content'))">
    {{ content }}
  </div>
  <!-- 右侧 -->
  <div
    v-if="operation || suffixIconComp"
    :class="classes(n('suffix'))"
  >
    <!-- 右侧操作按钮 -->
    <div
      v-if="operation"
      :class="classes(n('operation'))"
      role="button"
      :aria-label="operation"
      @click.stop="onClickOperation"
    >
      {{ operation }}
    </div>
    <!-- 右侧icon -->
    <div
      v-if="suffixIconComp"
      :class="classes(n('suffix-icon'), n(`suffix-icon--${suffixIcon}`))"
      role="button"
      :aria-label="suffixIconAriaLabel"
      @click="onClickSuffixIcon"
    >
      <component
        :is="suffixIconComp"
        width="1em"
      />
    </div>
  </div>
</div>
